<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/119woBh/tc-custom/9781035829705.jpg?1718182736750" alt="This image is the cover for the book Second Reality"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Second Reality
      </h1>
      <p class="bookDescription body article font2">
        <p>Hope is struggling with life. Her parents torment her, her friends don’t value her, and the anxiety within is cutting through to the surface. Traumatized by her existence, she could not know that through this long, lonely time, someone would eventually come to save her. Yet escaping an abusive home doesn’t magically erase years of pain. And in this case – there are more years than she can even remember. Hope is confronted by a claim that her whole life is a sadistic game, orchestrated by a powerful man from her past. Someone who had erased her memory. Someone who had reversed her biological age. Someone who threw her, as if a newborn, into a house of horrors. If a second chance at life is where hope comes to die, then a second reality must truly be a whole new world.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stacey Harder
      </h2>
      
      <p class="authorDescription body article">Stacey Fischer was born 1990 in Melbourne, Australia. Some of her lyrical/vocal work may be found through the indie-rock band, Astrohym. The tale within her first novel however, seemed to her, far too elaborate to be held by song. Whether her words are sung or written, every note is inspired by the meet-cute of heart-felt experience, prolific embellishment, and sometimes, even the truth. Second Reality was the first ever novel authored by Stacey. The words therein began as her 14-year-old self-made wishes for those things she did not have. Now, her only wish is to share the story with you.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?35601e1a